module.exports = __webpack_public_path__ + "img/collection-engagementRings070Carat@2x.8de3a78.jpg";